module.exports = __webpack_public_path__ + "static/media/icon_deals.f167f004.svg";